import React, { useState } from 'react';

const Other = () => {
  const [activeSection, setActiveSection] = useState('section1');

  const mockData = {
    section1: {
      pageNumber: 1,
      items: [
        {
          mudda: 9,
          title: 'सीमा दर्शक खुणाबाबतचा दावला',
          content: 'प्रमाणित करण्यात येते की, अकोला-खंडवा गेज परिवर्तन-प्रस्तावित डॅब्लीजसाठी भूसंपादन प्रस्तावाकरीता संपादीत करावयाच्या जमिनीचे प्रस्ताव तयार करण्यात आले असुन भुसंपादन प्रस्तावातील सदरचे क्षेत्र ज्या क्षेत्रजुट जाते त्या क्षेत्रजुट केरमोधाचे कोचवार पक्के डॅगांकाळ केले आहे.'
        },
        {
          mudda: 90,
          title: 'पंचवाचना',
          content: 'प्रमाणित करण्यात येते की, अकोला-खंडवा गेज परिवर्तन-प्रस्तावित डॅब्लीजसाठी भूसंपादन प्रस्तावाकरीता संपादीत करावयाच्या जमिनीचे प्रस्ताव तयार करण्यात आले असुन भुसंपादन प्रस्तावातील सदरचे क्षेत्र ज्या क्षेत्रजुट जाते त्या संपादित करावयाच्या प्रस्तावातील जमिनीच्या तांबे बेतलेला नाही त्यांचुळे मालकांस भुभागे दिले नाही. मिरिट, मिलखाती, मालावेधरी, पाटबंधारे, आदीचे किंवा वस्तीबाबत तपशील प्रत्यक्ष मोजणी तिकोशा (बूर्वोग सर्वेक्षण आंकडे) येणार आहेत तसेच नाजुळ तमाम केली आहे. तपशीलची स्वतःत्राणे जोड्टता आहे.'
        },
        {
          mudda: 92,
          title: 'भूभागे देणे प्रमाणपत्र',
          content: 'प्रमाणित करण्यात येते की, अकोला-खंडवा गेज परिवर्तन-प्रस्तावित डॅब्लीजसाठी भूसंपादन प्रस्तावाकरीता संपादीत करावयाच्या जमिनीच्या प्रस्ताव तयार करण्यात आले असुन भुसंपादन प्रस्तावातील सदरचे क्षेत्र ज्या क्षेत्रजुट जाते त्या संपादित करावयाच्या प्रस्तावातील जमिनीच्या तांबे बेतलेला नाही त्यांचुळे मालकांस भुभागे दिले नाही.'
        },
        {
          mudda: 93,
          title: 'प्रस्ताव दुबार वसलोबाबतचा दावला',
          content: 'प्रमाणित करण्यात येते की, अकोला-खंडवा गेज परिवर्तन-प्रस्तावित डॅब्लीजसाठी भूसंपादन प्रस्तावाकरीता संपादीत करावयाच्या जमिनीचे प्रस्ताव तयार करण्यात आले असुन भुसंपादन प्रस्तावातील सदरचे क्षेत्र ज्या क्षेत्रजुट जाते तेथील जमीन संपादन करण्याचा प्रस्ताव तयार करण्यात आला आहे. तयार करण्यात आलेला सदर प्रस्ताव दुबार नाही.'
        }
      ]
    },
    section2: {
      pageNumber: 2,
      items: [
        {
          mudda: 94,
          title: 'ताबे पावती',
          content: 'प्रमाणित करण्यात येते की, अकोला-खंडवा गेज परिवर्तन-प्रस्तावित डॅब्लीजसाठी भूसंपादन प्रस्तावाकरीता संपादीत करावयाच्या जमिनीचे प्रस्ताव तयार करण्यात आले असुन भुसंपादन प्रस्तावातील सदरचे क्षेत्र (परिशिष्ट \'अ\' प्रमाणे) ज्या क्षेत्रजुट जाते तेथील भुसंपादन प्रस्तावातील जमिनीच्या ताबे बेतलेला नाही त्यांचुळे ताबे पावती दिली नाही.'
        },
        {
          mudda: 95,
          title: '७/१२ व ८/अ चे उतारे',
          content: 'प्रमाणित करण्यात येते की, अकोला-खंडवा गेज परिवर्तन-प्रस्तावित डॅब्लीजसाठी भूसंपादन प्रस्तावाकरीता संपादीत करावयाच्या जमिनीचे प्रस्ताव तयार करण्यात आले असुन भुसंपादन प्रस्तावातील सदरचे क्षेत्र (परिशिष्ट \'अ\' प्रमाणे) ज्या क्षेत्रजुट जाते तेथील भुसंपादन प्रस्तावातील जमिनीची साधू आर्थिक वर्षानूसार ७/१२ व ८/अ चे उतारे मुद्रितण्णाणे जोडला आहेत.'
        },
        {
          mudda: 20,
          title: 'आरक्षण नसल्याबाबतचा दावला',
          content: 'प्रमाणित करण्यात येते की, अकोला-खंडवा गेज परिवर्तन-प्रस्तावित डॅब्लीजसाठी भूसंपादन प्रस्तावाकरीता संपादीत करावयाच्या जमिनीची प्रस्ताव तयार करण्यात आला आहे. सदर प्रस्तावातील कुटुम्बाची अधिकृत कोणत्याही प्रकारचे आरक्षण नसल्याचुळे सहायस्य सर्वसाधारण बाबर सर्वसाधारकार नथीमध्येर तसे प्रस्तावात सर्वासीष्ट करण्यात आले नाही.'
        },
        {
          mudda: 21,
          title: 'पुर्वसंचन नसल्याबाबतचा दावला',
          content: 'प्रमाणित करण्यात येते की, अकोला-खंडवा गेज परिवर्तन-प्रस्तावित डॅब्लीजसाठी भूसंपादन प्रस्तावाकरीता संपादीत करावयाच्या जमिनीची प्रस्ताव तयार करण्यात आला आहे. सदर प्रस्तावातील कुटुम्बाची अधिकृत कोणत्याही प्रकारचे पुर्वसंचन लागू नसल्याचुळे पुर्वसंचन शासडेकडील अभिप्राय प्रस्तावात समाविष्ट करण्यात आला नाही. सदर प्रश्नाचा सादर करून तरी त्या तसरुरी आवश्यकता नाहीं त्यांचुळे पुर्वसंचन तरयतेझोणांचे आवश्यक त्या अभियुक्याना जारी करण्याची आवश्यकता नाही.'
        }
      ]
    },
    section3: {
      pageNumber: 3,
      items: [
        {
          mudda: 26,
          title: 'वन झाल्याच्या जमिनीचा दावला',
          content: 'प्रमाणित करण्यात येते की, अकोला-खंडवा गेज परिवर्तन-प्रस्तावित डॅब्लीजसाठी भूसंपादन प्रस्तावाकरीता संपादीत करावयाच्या जमिनीची प्रस्ताव तयार करण्यात आला आहे. सदर प्रस्तावातील संपादन क्षेत्र हे अस्तित्वातील रेल्वे मार्ग व त्याच्या कडचे असलेल्या शेतजमिनीचे अतुल क्षेत्र हे वन झाल्याच्या कोणत्याही जमिनीतुन जात नाही.'
        },
        {
          mudda: 27,
          title: 'गावठाण क्षेत्रातील जमीन',
          content: 'प्रमाणित करण्यात येते की, अकोला-खंडवा गेज परिवर्तन-प्रस्तावित डॅब्लीजसाठी भूसंपादन प्रस्तावाकरीता संपादीत करावयाच्या जमिनीची प्रस्ताव तयार करण्यात आला असुन भुसंपादन प्रस्तावातील सदरचे क्षेत्र गावठाण क्षेत्रातुन जात नाही. त्यांचुळे जिल्हा आरोग्य खाल्याच्या मार्फत प्रमाणपत्र देण्याची आवश्यकता नाही.'
        },
        {
          mudda: 28,
          title: 'प्रमाणपत्र',
          content: 'प्रमाणित करण्यात येते की, अकोला-खंडवा गेज परिवर्तन-प्रस्तावित डॅब्लीजसाठी भूसंपादन प्रस्तावाकरीता संपादीत करावयाच्या जमिनीची प्रस्ताव तयार करण्यात आला असुन भुसंपादन प्रस्तावातील सदरचे क्षेत्र गावठाण क्षेत्रातुन जात नाही तसेच खातेदार भूधारीत / अत्यधातरक होऊ नयेत व चाकरीता योजाना बहाल करण्याची तसेच अन्य पर्याय उपलब्ध करण्याची आवश्यकता आली आहे.'
        },
        {
          mudda: 32,
          title: 'प्रमाणपत्र',
          content: 'प्रमाणित करण्यात येते की, अकोला-खंडवा गेज परिवर्तन-प्रस्तावित डॅब्लीजसाठी भूसंपादन प्रस्तावाकरीता संपादीत करावयाच्या जमिनीची प्रस्ताव तयार करण्यात आला असुन सदर प्रस्ताव हा रु. ५०,००,००,०००/- (अक्षरी रु. पन्नास कोटी) पेक्षा जास्त असल्यामुळे सदर प्रस्तावास पर्यावरण विभागास बाहेरकरत दाखला पेषणाम येईल.'
        },
        {
          mudda: 33,
          title: 'प्रमाणपत्र',
          content: 'प्रमाणित करण्यात येते की, अकोला-खंडवा गेज परिवर्तन-प्रस्तावित डॅब्लीजसाठी भूसंपादन प्रस्तावाकरीता संपादीत करावयाच्या जमिनीची प्रस्ताव तयार करण्यात आला असुन सदर प्रस्ताव हा रु. ५०,००,००,०००/- (अक्षरी रु. पन्नास कोटी) पेक्षा जास्त असल्यामुळे सदर प्रस्तावास मिल्योजन प्रालीकरणासाच बाहेरकरत दाखला पेषणाम येईल.'
        }
      ]
    },
    section4: {
      pageNumber: 4,
      items: [
        {
          mudda: 34,
          title: 'हवीपत्र',
          content: 'प्रमाणित करण्यात येते की, अकोला-खंडवा गेज परिवर्तन-प्रस्तावित डॅब्लीजसाठी भूसंपादन प्रस्तावाकरीता संपादीत करावयाच्या जमिनीची प्रस्ताव तयार करण्यात आले आहे. सदर प्रस्तावाल संपादनासाठी सुरक्षितेचा / प्रस्तावित करण्यात आलेले क्षेत्र आवश्यक तसेच संपादित करावयाच्या क्षेत्रा असून अतिरिक्त किंवा बालगटल्या क्षेत्राची बाहेरमध्ये अस्तित्व नाही. सेनालासाठी प्रस्तावित केलेला क्षेत्रजुळे काही कल्पबाह अत्यभारक/ भुत्वरक होत असले तरी प्रस्तावीत क्षेत्र संपादित करण्याचेरीच गलबाह नाही.'
        },
        {
          mudda: 35,
          title: 'प्रमाणपत्र',
          content: 'प्रमाणित करण्यात येते की अकोला-खंडवा गेज परिवर्तन-प्रस्तावित डॅब्लीजसाठी भूसंपादन प्रस्तावाकरीता संपादीत करावयाच्या जमिनीची प्रस्ताव तयार करण्यात आला आहे. भूसंपादनासाठी साधू आर्थिक वर्षा २०२५-२०२६ आवश्यक मिधीची तरतूद करण्यात आली आहे.'
        },
        {
          mudda: 36,
          title: 'प्रमाणपत्र',
          content: 'प्रमाणित करण्यात येते की अकोला-खंडवा गेज परिवर्तन-प्रस्तावित डॅब्लीजसाठी भूसंपादन प्रस्तावाकरीता संपादीत करावयाच्या जमिनीची प्रस्ताव तयार करण्यात आला असुन आवश्यक त्या निधीची तरतूद प्रस्तावात करण्यात आली आहे. तसेच कलम ४ थ्या अधिसुचनापुर्वी २/३ रक्कम व अन्नेस रक्कम कलम ११ जालेला मिद्या जाहीर करतांना करण्यात येईल.'
        },
        {
          mudda: 37,
          title: 'प्रमाणपत्र',
          content: 'प्रमाणित करण्यात येते की, अकोला-खंडवा गेज परिवर्तन-प्रस्तावित डॅब्लीजसाठी भूसंपादन प्रस्तावाकरीता संपादीत करावयाच्या जमिनीची प्रस्ताव तयार करण्यात आला असुन भुसंपादन शासलेकडे भुसंपादनासाठी सादर करण्यात आले आहे. तसेच २१.९०.२०२५ पर्यंत या विभागाकडे केसलीही मालणी वहीन अद्याप प्राप्तीच नाही.'
        }
      ]
    }
  };

  const handleSectionClick = (sectionKey) => {
    setActiveSection(sectionKey);
  };

  const currentData = mockData[activeSection];

  const styles = {
    container: {
      fontFamily: "'Noto Sans Devanagari', 'Arial', sans-serif",
      backgroundColor: '#EEF2F7',
      minHeight: '100vh',
      padding: '0'
    },

    // ── tabs (theme colours kept) ──
    tabContainer: {
      display: 'flex',
      width: '100%',
      margin: 0,
      padding: '15px 20px',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#ffffff',
      boxShadow: '0 2px 8px rgba(27,42,74,0.1)',
      flexWrap: 'wrap',
      gap: '10px'
    },
    tabButton: (isActive) => ({
      flex: 1,
      padding: '10px 0',
      fontSize: '16px',
      fontWeight: '600',
      border: 'none',
      borderRadius: '8px',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      backgroundColor: isActive ? '#1D4ED8' : '#D6DEE6',
      color: isActive ? '#ffffff' : '#1D4ED8',
      boxShadow: isActive
        ? '0 4px 12px rgba(107,131,153,0.4)'
        : '0 2px 4px rgba(74, 49, 27, 0.1)',
      transform: isActive ? 'translateY(-2px)' : 'translateY(0)'
    }),

    // ── white "paper" page ──
    contentContainer: {
      maxWidth: '850px',
      margin: '30px auto',
      padding: '0 20px'
    },
    contentCard: {
      backgroundColor: '#ffffff',
      borderRadius: '4px',
      boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      minHeight: '88vh'
    },

    // ── document body ──
    contentBody: {
      padding: '55px 60px 20px 60px',
      flex: 1,
      overflowY: 'auto'
    },

    // each mudda block
    documentItem: {
      marginBottom: '30px'
    },

    // मुद्दा क्र. ९  — plain, black, left
    muddaNumber: {
      color: '#000000',
      fontWeight: '400',
      fontSize: '15px',
      marginBottom: '4px',
      textAlign: 'left'
    },

    // सीमा दर्शक खुणाबाबतचा दावला — centre, bold, underlined
    documentTitle: {
      fontSize: '16px',
      fontWeight: '700',
      color: '#000000',
      margin: '2px 0 8px 0',
      textAlign: 'center',
      textDecoration: 'underline',
      textUnderlineOffset: '3px',
      lineHeight: '1.6'
    },

    // body paragraph — justified, first-line indent
    documentContent: {
      fontSize: '15px',
      lineHeight: '1.85',
      color: '#000000',
      textAlign: 'justify',
      textIndent: '30px',
      padding: 0,
      margin: 0
    },

    // ── footer at the bottom, right-aligned ──
    footer: {
      backgroundColor: '#ffffff',
      padding: '50px 60px 45px 60px',
      textAlign: 'right'
    },
    footerText: {
      fontSize: '15px',
      color: '#000000',
      margin: '2px 0',
      fontWeight: '400'
    }
  };

  return (
    <div style={styles.container}>

      {/* Tabs */}
      <div style={{ padding: 0, margin: 0 }}>
        <div style={styles.tabContainer}>
          {['section1', 'section2', 'section3', 'section4'].map((key, i) => (
            <button
              key={key}
              style={styles.tabButton(activeSection === key)}
              onClick={() => handleSectionClick(key)}
              onMouseOver={(e) => {
                if (activeSection !== key) e.target.style.backgroundColor = '#C2CDD6';
              }}
              onMouseOut={(e) => {
                if (activeSection !== key) e.target.style.backgroundColor = '#D6DEE6';
              }}
            >
              पृष्ठ {i + 1}
            </button>
          ))}
        </div>
      </div>

      {/* White paper page */}
      <div style={styles.contentContainer}>
        <div style={styles.contentCard}>

          {/* Document body — no coloured header */}
          <div style={styles.contentBody}>
            {currentData.items.map((item, index) => (
              <div key={index} style={styles.documentItem}>
                <div style={styles.muddaNumber}>मुद्दा क्र. {item.mudda}</div>
                <h3 style={styles.documentTitle}>{item.title}</h3>
                <p style={styles.documentContent}>{item.content}</p>
              </div>
            ))}
          </div>

          {/* Footer — bottom right */}
          <div style={styles.footer}>
            <p style={styles.footerText}>उपकार्यकारी अभियंता, (बांधकाम विभाग),</p>
            <p style={styles.footerText}>दक्षिण मध्य रेल्वे, अकोला</p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Other;